var __default__ = {root:'m_e2125a27',closeButton:'m_5abab665'};
export default __default__;